import { useEffect, useRef, useState } from 'react';

/**
 * Simple IntersectionObserver hook
 * @param {Object} options - { rootMargin, threshold, once }
 * @returns [ref, inView]
 */
export default function useInView({ root = null, rootMargin = '0px', threshold = 0.15, once = true } = {}) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setInView(true);
            if (once) observer.unobserve(entry.target);
          } else if (!once) {
            setInView(false);
          }
        });
      },
      { root, rootMargin, threshold }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [root, rootMargin, threshold, once]);

  return [ref, inView];
}
